export default __webpack_public_path__ + "assets/images/658d63055dd89df8b8b7057d8fe98b08.svg";